import React, { useState } from 'react';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import AudienceHero from '../../components/AudienceHero';
import HowItWorks from '../../components/HowItWorks';
import MindsetQuizPromo from '../../components/MindsetQuizPromo';
import SimplifiedPricing from '../../components/SimplifiedPricing';
import { LeadMagnetPromo, COACH_PLAYBOOK_CONFIG } from '../../components/LeadMagnetPromo';
import FinalCTABanner from '../../components/FinalCTABanner';
import PrivacyPolicy from '../../components/PrivacyPolicy';
import { CALENDLY_URL, LOGO_URL, INSTAGRAM_URL } from '../../lib/siteConfig';

/**
 * /coaches — dedicated landing for HS / club / college coaches.
 */
export default function CoachesPage() {
  const [privacyOpen, setPrivacyOpen] = useState(false);
  return (
    <div className="min-h-screen bg-background text-foreground" data-testid="coaches-page">
      <Navbar calendlyLink={CALENDLY_URL} logoUrl={LOGO_URL} />
      <main>
        <AudienceHero
          testIdPrefix="coaches-hero"
          eyebrow="For Coaches"
          headline="Build a mentally tough program. One framework, all six dimensions."
          subhead="For HS, club, and college coaches who watch talented athletes freeze in the moments that matter. Bring the Apex Six into your practices, your locker room talks, and your one-on-ones — with workshops, consultation, and an in-pocket coach for your roster."
          primaryCta={{ href: CALENDLY_URL, label: 'Book a Call About Your Team', external: true }}
          secondaryCta={{ href: '/workshops', label: 'See the Workshop Catalog' }}
        />

        {/* How it works for coaches — 3-step path before resources */}
        <HowItWorks variant="coach" />

        <LeadMagnetPromo config={COACH_PLAYBOOK_CONFIG} />
        <MindsetQuizPromo />
        <SimplifiedPricing calendlyLink={CALENDLY_URL} />

        <FinalCTABanner
          headline="Bring mental performance to your program."
          subhead="Discovery Calls are free. Walk in with your roster, your season goals, and the moments where the mental side keeps slipping. Leave with a plan you can run on Monday."
          primaryHref={CALENDLY_URL}
          primaryLabel="Book a Discovery Call"
          secondaryHref="/workshops"
          secondaryLabel="View Workshops"
        />
      </main>
      <Footer
        calendlyLink={CALENDLY_URL}
        instagramLink={INSTAGRAM_URL}
        logoUrl={LOGO_URL}
        onPrivacyClick={() => setPrivacyOpen(true)}
      />
      <PrivacyPolicy open={privacyOpen} onClose={() => setPrivacyOpen(false)} />
    </div>
  );
}
